import VueFormulate from '@braid/vue-formulate'
import SelectInputResourceful from '@/components/formulate/SelectInputResourceful'
import SelectInputResourcefulV2 from '@/components/formulate/SelectInputResourcefulV2'
import SelectInputResourcefulV3 from '@/components/formulate/SelectInputResourcefulV3'
import CustomInputLabel from '@/components/formulate/CustomInputLabel'
import CustomInputHelpText from '@/components/formulate/CustomInputHelpText'
import TextInput from '@/components/formulate/TextInput'
import TextareaInput from '@/components/formulate/TextareaInput'
import ValueHelpInput from '@/components/formulate/ValueHelpInput'
import ValueHelpInputV2 from '@/components/formulate/ValueHelpInputV2'
import TableAudioPlayer from '@/components/formulate/ValueHelpInputV2/components/TableAudioPlayer'
import DynamicCell from '@/components/formulate/ValueHelpInputV2/components/DynamicCell'
import RouteValueHelp from '@/components/formulate/RouteValueHelp'
import VendorValueHelp from '@/components/formulate/VendorValueHelp'
import VendorValueHelpV2 from '@/components/formulate/VendorValueHelpV2'
import CustomDatePicker from '@/components/formulate/CustomDatePicker'
import SwitchInput from '@/components/formulate/SwitchInput'
import CounterInput from '@/components/formulate/CounterInput'
import ReportFilterValueHelp from '@/components/formulate/ReportFilterValueHelp'
import TrackvisionFilterValueHelp from '@/components/formulate/TrackvisionFilterValueHelp'
import PhoneInput from '@/components/formulate/PhoneInput'
import TimeDurationInput from '@/components/formulate/TimeDurationInput'
import HourMinuteInput from '@/components/formulate/HourMinuteInput'
import GeofenceValueHelp from '@/components/formulate/GeofenceValueHelp'
import ImageInput from '@/components/formulate/ImageUpload'
import TaggableSelectInput from '@/components/formulate/TaggableSelectInput'
import ChoiceChips from '@/components/formulate/ChoiceChips'
import ReadOnly from '@/components/formulate/ReadOnly'
import FileInput from '@/components/formulate/FileInput'
import FileUploaderCustom from '@/components/formulate/FileUploaderCustom'

import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js'
import moment from 'moment'
import i18n from '@/i18n'

// NOTE:
// This plugins requires these dependencies:
// - Vue Bootstrap
// - Datepicker
// So it should be called after those dependencies are registered
// we can re-import and register them here but need to check will it increase
// the bundle size

export default {
  install(Vue) {
    // register your component with Vue
    Vue.component('SelectInputResourceful', SelectInputResourceful)
    Vue.component('SelectInputResourcefulV2', SelectInputResourcefulV2)
    Vue.component('SelectInputResourcefulV3', SelectInputResourcefulV3)
    Vue.component('CustomInputLabel', CustomInputLabel)
    Vue.component('CustomInputHelpText', CustomInputHelpText)
    Vue.component('TextInput', TextInput)
    Vue.component('TextareaInput', TextareaInput)
    Vue.component('ValueHelpInput', ValueHelpInput)
    Vue.component('ValueHelpInputV2', ValueHelpInputV2)
    Vue.component('TableAudioPlayer', TableAudioPlayer)
    Vue.component('DynamicCell', DynamicCell)
    Vue.component('RouteValueHelp', RouteValueHelp)
    Vue.component('VendorValueHelp', VendorValueHelp)
    Vue.component('VendorValueHelpV2', VendorValueHelpV2)
    Vue.component('CustomDatePicker', CustomDatePicker)
    Vue.component('SwitchInput', SwitchInput)
    Vue.component('CounterInput', CounterInput)
    Vue.component('ReportFilterValueHelp', ReportFilterValueHelp)
    Vue.component('TrackvisionFilterValueHelp', TrackvisionFilterValueHelp)
    Vue.component('PhoneInput', PhoneInput)
    Vue.component('TimeDurationInput', TimeDurationInput)
    Vue.component('HourMinuteInput', HourMinuteInput)
    Vue.component('GeofenceValueHelp', GeofenceValueHelp)
    Vue.component('ImageInput', ImageInput)
    Vue.component('TaggableSelectInput', TaggableSelectInput)
    Vue.component('ChoiceChips', ChoiceChips)
    Vue.component('ReadOnly', ReadOnly)
    Vue.component('FileInput', FileInput)
    Vue.component('FileUploaderCustom', FileUploaderCustom)

    Vue.use(VueFormulate, {
      // Adds tooltips, etc. to the input labels
      // More info https://vueformulate.com/guide/inputs/slots/#slot-components
      slotComponents: {
        label: 'CustomInputLabel',
        help: 'CustomInputHelpText',
      },

      slotProps: {
        help: ['size'],
      },

      // Custom inputs
      library: {
        // Overrides text input to implement masking functionality
        text: {
          classification: 'text',
          component: 'TextInput',
          slotProps: {
            component: ['size', 'clearable', 'variant', 'underline'],
          },
        },
        textarea: {
          classification: 'text',
          component: 'TextareaInput',
          slotProps: {
            component: ['clearable'],
          },
        },
        'date-picker': {
          classification: 'text',
          component: 'CustomDatePicker',
          slotProps: {
            component: ['size', 'datepickerType', 'clearable', 'icon'],
          },
        },
        'select-resourceful': {
          classification: 'search',
          component: 'SelectInputResourceful',
          slotProps: {
            component: [
              'initialObject',
              'trackBy',
              'optionLabelFn',
              'useInitialFallback',
              'optionsGetter',
              'multiple',
              'size',
              'hasImage',
              'tagCustom',
              'taggable',
              'handleChange',
              'handleInit',
              'rowItem',
              'hasOptionMeta',
              'metaRightComponent',
            ],
          },
        },
        'select-resourceful-v2': {
          classification: 'search',
          component: 'SelectInputResourcefulV2',
          slotProps: {
            component: [
              'fullObject',
              'trackBy',
              'optionLabelFn',
              'selectedLabel',
              'optionsGetter',
              'multiple',
              'size',
              'hasImage',
              'tagCustom',
              'taggable',
              'hasDelete',
              'isMandatory',
              'hasIconSearch',
              'rowItem',
            ],
          },
        },
        'select-resourceful-v3': {
          classification: 'search',
          component: 'SelectInputResourcefulV3',
          slotProps: {
            component: [
              'fullObject',
              'trackBy',
              'optionLabelFn',
              'optionsGetter',
              'multiple',
              'size',
              'hasImage',
              'tagCustom',
              'taggable',
              'disabled',
              'hasClose',
              'selectedLabel',
              'visibleTagCount',
              'hasAttachment',
              'attachmentKey',
              'hasOptionMeta',
              'metaRightComponent',
              'showSelectionCount',
            ],
          },
        },
        'value-help': {
          classification: 'search',
          component: 'ValueHelpInput',
          slotProps: {
            component: [
              'listGetter',
              'tableFields',
              'trackBy',
              'displayedBy',
              'initialObject',
              'size',
            ],
          },
        },
        'value-help-v2': {
          classification: 'search',
          component: 'ValueHelpInputV2',
          slotProps: {
            component: [
              'fullObject',
              'size',
              'disabled',
              'multiple',
              'displayedBy',
              'multiple',
              'canBeNull',
              'identifier',
            ],
          },
        },
        'route-value-help': {
          classification: 'search',
          component: 'RouteValueHelp',
          slotProps: {
            component: [
              'fullObject',
              'size',
              'disabled',
              'multiple',
              'displayedBy',
              'multiple',
              'canBeNull',
              'identifier',
            ],
          },
        },
        'vendor-value-help': {
          classification: 'search',
          component: 'VendorValueHelp',
          slotProps: {
            component: ['fullObject', 'size', 'disabled', 'multiple', 'displayedBy', 'multiple'],
          },
        },
        'vendor-value-help-v2': {
          classification: 'search',
          component: 'VendorValueHelpV2',
          slotProps: {
            component: ['fullObject', 'size', 'disabled', 'multiple', 'displayedBy', 'multiple'],
          },
        },
        'report-filter-value-help': {
          classification: 'search',
          component: 'ReportFilterValueHelp',
          slotProps: {
            component: ['fullObject', 'size', 'disabled', 'multiple', 'displayedBy', 'multiple'],
          },
        },
        'trackvision-filter-value-help': {
          classification: 'search',
          component: 'TrackvisionFilterValueHelp',
          slotProps: {
            component: ['fullObject', 'size', 'disabled', 'multiple', 'displayedBy', 'multiple'],
          },
        },
        'geofence-value-help': {
          classification: 'search',
          component: 'GeofenceValueHelp',
          slotProps: {
            component: [
              'fullObject',
              'size',
              'disabled',
              'multiple',
              'displayedBy',
              'multiple',
              'geofenceAllData',
            ],
          },
        },
        switch: {
          // using 'text' instead of 'box' so we can set initial value with
          // 'value' instead of 'checked'
          // classification: 'box',
          classification: 'text',
          component: 'SwitchInput',
          slotProps: {
            component: [
              'valueTrue',
              'valueFalse',
              'valueLabelTrue',
              'valueLabelFalse',
              'valueLabelPosition',
            ],
          },
        },
        counter: {
          classification: 'text',
          component: 'CounterInput',
        },
        'phone-number': {
          classification: 'text',
          component: 'PhoneInput',
          slotProps: {
            component: ['size', 'countryCode', 'placeholder', 'disabled'],
          },
        },
        'time-duration': {
          classification: 'search',
          component: 'TimeDurationInput',
          slotProps: {
            component: ['size', 'optionItems'],
          },
        },
        'hour-minute': {
          classification: 'text',
          component: 'HourMinuteInput',
          slotProps: {
            component: ['size'],
          },
        },
        'image-input': {
          classification: 'file',
          component: 'ImageInput',
          slotProps: {
            component: ['isFileError', 'onFileChange', 'fileName', 'onRemove'],
          },
        },
        'taggable-select-input': {
          classification: 'search',
          component: 'TaggableSelectInput',
          slotProps: {
            component: ['placeholder', 'size', 'trackBy', 'tagPlaceholder', 'optionLabelFn'],
          },
        },
        'choice-chips': {
          classification: 'text',
          component: 'ChoiceChips',
          slotProps: {
            component: ['options', 'multiple', 'trackBy', 'label', 'disabled', 'allValue'],
          },
        },
        'read-only': {
          classification: 'text',
          component: 'ReadOnly',
          slotProps: {
            component: ['title', 'result', 'isError'],
          },
        },
        'file-input': {
          classification: 'file',
          component: 'FileInput',
          slotProps: {
            component: ['size', 'buttonText', 'helpText', 'onFileChange', 'maxSize'],
          },
        },
        'file-uploader-custom': {
          classification: 'file',
          component: 'FileUploaderCustom',
          slotProps: {
            component: [
              'label',
              'maxSize',
              'allowedFormats',
              'required',
              'multiple',
              'maxFiles',
              'readonly',
              'disabled',
              'showAllowedFormats',
            ],
          },
        },
        'table-audio-player': {
          classification: 'text',
          component: 'TableAudioPlayer',
          slotProps: {
            component: ['size'],
          },
        },
      },

      // Custom validation rules
      rules: {
        timeGteNow: ({ value }) => {
          // if not picking up any date from vue2-datepicker, the variable value is returning 'Invalid Date'
          if (value === 'Invalid date') return true

          const checkFormat = moment(value, 'DD MMM YYY', true).isValid()
          if (!checkFormat) {
            if (moment(value).isValid()) {
              value = moment(value)
            } else {
              return true
            }
          }

          return moment(value).isSameOrAfter(moment())
        },
        timeLteNow: ({ value }) => {
          if (value === 'Invalid date') return true
          return moment(value).isSameOrBefore(moment())
        },
        timeGteField: ({ getFormValues, value }, args) => {
          if ((Array.isArray(args) && args.length !== 1) || !args) {
            throw new Error(
              'dateGteField validation rule requires 1 argument, which is the name of the target field name to compare to'
            )
          }

          const formValues = getFormValues()
          const targetFieldName = args

          // return true so that the other fields can be optional
          if (!formValues[targetFieldName]) {
            return true
          }

          if (value === 'Invalid date') return true

          const checkFormat = moment(value).isValid()
          if (!checkFormat) {
            if (moment(value).isValid()) {
              value = moment(value)
            } else {
              return true
            }
          }

          return moment(value).isSameOrAfter(formValues[targetFieldName])
        },
        timeLteField: ({ getFormValues, value }, args) => {
          if ((Array.isArray(args) && args.length !== 1) || !args) {
            throw new Error(
              'dateLteField validation rule requires 1 argument, which is the name of the target field name to compare to'
            )
          }

          const formValues = getFormValues()
          const targetFieldName = args

          // return true so that the target fields can be optional
          if (!formValues[targetFieldName]) {
            return true
          }

          if (value === 'Invalid date') return true
          return moment(value).isSameOrBefore(moment(formValues[targetFieldName]))
        },
        dateGteNow: ({ value }) => {
          // if not picking up any date from vue2-datepicker, the variable value is returning 'Invalid Date'
          if (value === 'Invalid date') return true

          const checkFormat = moment(value, 'DD MMM YYY', true).isValid()
          if (!checkFormat) {
            if (moment(value, 'YYYY-MM-DD', true).isValid()) {
              value = moment(value, 'YYYY-MM-DD').format('DD MMM YYYY')
            } else {
              return true
            }
          }

          return moment(value, 'DD MMM YYYY', 'id').isSameOrAfter(moment(), 'day')
        },
        dateLteNow: ({ value }) => {
          if (value === 'Invalid date') return true
          return moment(value, 'DD MMM YYYY', 'id').isSameOrBefore(moment(), 'day')
        },
        dateGteField: ({ getFormValues, value }, args) => {
          if ((Array.isArray(args) && args.length !== 1) || !args) {
            throw new Error(
              'dateGteField validation rule requires 1 argument, which is the name of the target field name to compare to'
            )
          }

          const formValues = getFormValues()
          const targetFieldName = args

          // return true so that the other fields can be optional
          if (!formValues[targetFieldName]) {
            return true
          }

          if (value === 'Invalid date') return true

          // Check if value is in ISO format
          const isISOFormat = value.includes('T')

          if (isISOFormat) {
            return moment(value, 'YYYY-MM-DDTHH:mm:ss.SSSZ').isSameOrAfter(
              moment(formValues[targetFieldName], 'YYYY-MM-DDTHH:mm:ss.SSSZ'),
              'day'
            )
          }

          const checkFormat = moment(value, 'DD MMM YYY', true).isValid()
          if (!checkFormat) {
            if (moment(value, 'YYYY-MM-DD', true).isValid()) {
              value = moment(value, 'YYYY-MM-DD').format('DD MMM YYYY')
            } else {
              return true
            }
          }

          return moment(value, 'DD MMM YYYY', 'id').isSameOrAfter(
            formValues[targetFieldName],
            'day'
          )
        },
        dateLteField: ({ getFormValues, value }, args) => {
          if ((Array.isArray(args) && args.length !== 1) || !args) {
            throw new Error(
              'dateLteField validation rule requires 1 argument, which is the name of the target field name to compare to'
            )
          }

          const formValues = getFormValues()
          const targetFieldName = args

          // return true so that the target fields can be optional
          if (!formValues[targetFieldName]) {
            return true
          }

          if (value === 'Invalid date') return true

          // Check if value is in ISO format
          const isISOFormat = value.includes('T')

          if (isISOFormat) {
            return moment(value, 'YYYY-MM-DDTHH:mm:ss.SSSZ').isSameOrBefore(
              moment(formValues[targetFieldName], 'YYYY-MM-DDTHH:mm:ss.SSSZ'),
              'day'
            )
          }

          return moment(value, 'DD MMM YYYY', 'id').isSameOrBefore(
            moment(formValues[targetFieldName], 'DD MMM YYYY', 'id'),
            'day'
          )
        },

        isoTimeGteValue: ({ value }, args) => {
          if ((Array.isArray(args) && args.length !== 1) || !args) {
            throw new Error(
              'isoTimeGteValue validation rule requires 1 argument, which is the value in iso string format'
            )
          }

          const isoTarget = moment.duration(args)
          const isoValue = moment.duration(value)

          return isoValue.asMilliseconds() >= isoTarget.asMilliseconds()
        },

        isUnique: ({ value, getFormValues, name }, args) => {
          if (!value) return true
          // args can be [dataList] or dataList itself depending on how it's called
          const list = Array.isArray(args[0]) ? args[0] : Array.isArray(args) ? args : []

          // Try to find if there's an ID to exclude (passed as second arg in some cases)
          const excludeId = args[1]
          const trackBy = args[2] || 'id'

          const data = list
            .filter((obj) => {
              if (excludeId && obj[trackBy] == excludeId) return false
              return true
            })
            .map((obj) => {
              if (!obj || typeof obj !== 'object') return ''
              const label = obj['label'] || obj['name'] || obj['action']
              return label ? String(label).toLowerCase() : ''
            })

          const validate = data.includes(String(value).toLowerCase())
          if (validate === true) return false
          return true
        },
        maxInterval: ({ _value }, args) => {
          const intervalTime = args.intervalTime * args.intPeriodeSelect?.time
          const reminderTime = args.reminderTime * args.reminderPeriodeSelect?.time
          if (intervalTime < reminderTime) return false

          return true
        },
        multipleSpaces: ({ value }) => {
          if (value.match(/ +(?= )/g) !== null) {
            return false
          }
          return true
        },
        integer: ({ value }) => {
          if (typeof value === 'string' && value.match(/\.+(?=)/g) !== null) return false
          return true
        },
        decimal: ({ value }, args) => {
          const parts = value.toString().split('.')
          if (parts.length == 2) {
            const lastIndex = parts.length - 1
            if (parts[lastIndex].length > args) {
              return false
            }
          }
          return true
        },
        isPhoneNumber: ({ value }, args) => {
          if (args == 'ID') {
            return parsePhoneNumber(value, 'ID').isValid()
          }

          if (args == '62' && value[0] == '0') {
            if (value[1] == '0') return false
            return false
          }
          if (value) {
            if (args.includes('+')) return isValidPhoneNumber(`${args}` + value)
            else return isValidPhoneNumber(`+${args}` + value)
          }

          return true
        },
        unique: ({ value }, args) => {
          let check
          if (args) check = args.filter((item) => item === value)
          if (check.length > 0) return false
          return true
        },
        isDuplicate: ({ value }) => {
          return value
        },
        trimRequired: ({ value }) => {
          if (typeof value === 'string') {
            return value.trim().length > 0
          }
          return !!value
        },
        minLessThanMax: ({ getFormValues }, minFieldKey, maxFieldKey) => {
          const formValues = getFormValues()
          const min = formValues[minFieldKey]
          const max = formValues[maxFieldKey]

          if (!min || !max) return true

          return Number(min) <= Number(max)
        },
        maxDigits: ({ value }, args) => {
          if (!value) return true
          return String(value).length <= parseInt(args[0])
        },
      },

      // Custom validation messages per rules
      locales: {
        en: {
          required: () => i18n.t('global.validation.required'),
          number: ({ name }) => `${name} ${i18n.t('global.validation.number')}`,
          email: ({ name }) => `${name} ${i18n.t('global.validation.email')}`,
          not: ({ args, name }) => `${name} ${i18n.t('global.validation.not')} ${args[0]}`,
          max: ({ args, name }) => {
            const [max, type] = args
            if (type === 'value')
              return `${name} ${i18n.t('global.validation.max')} ${(+max).toLocaleString()}`
            return `${name} ${i18n.t('global.validation.max')} ${(+max).toLocaleString()} ${i18n.t(
              'global.validation.character'
            )}`
          },
          min: ({ args, name }) => {
            const [min, type] = args
            if (type === 'value')
              return `${name} ${i18n.t('global.validation.min')} ${(+min).toLocaleString()}`
            return `${name} ${i18n.t('global.validation.min')} ${(+min).toLocaleString()} ${i18n.t(
              'global.validation.character'
            )}`
          },
          isoTimeGteValue: ({ args }) => {
            const dur = moment.duration(args)

            let result = ''
            if (dur.days() > 0) result += `${dur.days()} ${i18n.t('global.time.days')} `
            if (dur.hours() > 0) result += `${dur.hours()} ${i18n.t('global.time.hours')} `
            if (dur.minutes() > 0) result += `${dur.minutes()} ${i18n.t('global.time.minutes')} `
            if (dur.seconds() > 0) result += `${dur.seconds()} ${i18n.t('global.time.seconds')}`

            return i18n.t('global.validation.isoTimeGteValue', {
              value: result,
            })
          },
          isUnique: () => i18n.t('global.validation.unique'),
          multipleSpaces: ({ name }) => `${name} ${i18n.t('global.validation.multiSpaces')}`,
          integer: ({ name }) => `${name} ${i18n.t('global.validation.integer')}`,
          decimal: ({ args, name }) =>
            `${name} ${i18n.t('global.validation.maximal')} ${args} ${i18n.t(
              'global.validation.decimal'
            )}`,
          isPhoneNumber: () => i18n.t('global.validation.invalidNumber'),
          trimRequired: () => i18n.t('global.validation.required'),
        },
      },

      // Value to be shown in the error message
      // check for validation-name props first, then label, then the rest
      // https://vueformulate.com/guide/validation/#customize-validation-messages
      validationNameStrategy: ['validationName', 'label', 'name', 'type'],
    })
  },
}
